import { useEffect, useMemo, useState } from "react";
import { useAppThemeContext, useAuthContext } from "../../shered/contexts";
import { useNavigate, useSearchParams } from "react-router-dom";
import { FerramentasDeDetalhe, SelectComponent } from "../../shered/components";
import { VForm, useVForm } from "../../shered/forms";
import { LayoutBaseDePagina } from "../../shered/layouts";
import {
    Box, Paper, Typography, useTheme,
    Autocomplete,
    CircularProgress,
    TextField,
    Button,
    Icon,
    FormControl,
    InputLabel,
    Select,
    MenuItem
} from "@mui/material";
import { DataGrid, GridColDef, GridEventListener } from "@mui/x-data-grid";
import Grid from '@mui/material/Grid2';
import { FranquiaService, IDetalheFranquia, ILstDrop } from "../../shered/services/api/franquia/FranquiaService";
import { IListagemJogador, JogadorService } from "../../shered/services/api/jogador/JogadorService";
import { Loading } from "../../shered/components/loading/Loading";
import { TDropOptions, UtilidadeService, lstPosicaoAmericano, lstReferenciasPosicao, lstReferenciasPosicaoAmericano, lstReferenciasPosicaoConfronto } from "../../shered/services/api/utilidades/UtilidadesService";
import { DraftService } from "../../shered/services/api/draft/DraftService";
import { DialogMensagem, IDadosModal } from "../../shered/components/modal/DialogMensagem";
import { TDropOptionsJogador } from "../escalacao/DetalheDeEscalacao";
import { ptBR } from '@mui/x-data-grid/locales';
import { IListagemLigas, LigaService } from "../../shered/services/api/liga/LigaService";

export const ListagemDeJogadores: React.FC = () => {
    const theme = useTheme();
    const { formRef, save } = useVForm();
    const { themeName } = useAppThemeContext();
    let codLocal = localStorage.getItem("@codigoLiga");
    const [codigoLiga, setCodigoLiga] = useState(codLocal !== null ? UtilidadeService.decrypt(codLocal) : "0");
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(false);
    const { isAuthenticated, logout } = useAuthContext();
    const [edicao, setEdicao] = useState(false);
    const [removeLoading, setRemoveLoading] = useState(false);
    const [opcoesAutoCompleteJogador, setOpcoesAutoCompleteJogador] = useState<TDropOptions[]>([])    
    const [selectedIdComplete, setSelectedIdComplete] = useState<number | undefined>(0);
    const [rowsJogadores, setRowsJogadores] = useState<IListagemJogador[]>([]);       

    
    const [codigoFranquiaNbaFiltro, setCodigoFranquiaNbaFiltro] = useState(0);
    const [codigoFranquiaLigaFiltro, setCodigoFranquiaLigaFiltro] = useState(0);
    const [posicaoFiltro, setPosicaoFiltro] = useState("0");
    const [ativoFiltro, setAtivoFiltro] = useState(0);


    const [lstFranquiasNBA, setLstFranquiasNBA] = useState<ILstDrop[]>([]);
    const [lstFranquias, setLstFranquias] = useState<ILstDrop[]>([]);
    const [lstPosicoes, setLstPosicoes] = useState<ILstDrop[]>([]);

    const [searchParamsJogadores, SetSearchParams] = useSearchParams();
    const [redirecionar, setRedirecionar] = useState("0");
    const [showModalMensagem, setShowModalMensagem] = useState(false);
    const [dadosLiga, setDadosLiga] = useState<IListagemLigas>();

    const [dadosModalMensagem, setDadosModalMensagem] = useState<IDadosModal>({
        acao: false,
        label: "",
        tipo: "error",
        mensagem: "Sessão Expirada!",
        display: "none",
        titulo: "Atenção"
    });

    const columnsJogadores: GridColDef[] = [
        {
            field: 'codigo',
            headerName: 'ID',
            width: 60,
            sortable: UtilidadeService.isMobile() ? false : true,
            headerClassName: 'super-app-theme--header',
            headerAlign: "center",
            align: "center"
        },
        {
            field: 'foto',
            headerName: UtilidadeService.isMobile() ? "" : 'FOTO',
            flex: 1,
            hideable: false,
            sortable: false,
            minWidth: UtilidadeService.isMobile() ? 40 : 65,
            renderCell: (params) => (params.value !== null && params.value !== "" && params.value !== undefined)
                ? <img src={params.value} width={UtilidadeService.isMobile() ? 35 : 50} height={UtilidadeService.isMobile() ? 35 : 50}
                    onError={({ currentTarget }) => {
                        currentTarget.onerror = null;
                        currentTarget.src = "../../../../semimagem.png";
                        currentTarget.style.borderRadius = "50%";
                        currentTarget.style.width = UtilidadeService.isMobile() ? "30px" : "40px";
                        currentTarget.style.height = UtilidadeService.isMobile() ? "30px" : "40px";
                    }}
                />
                : <img src={"../../../../semimagem.png"} width={UtilidadeService.isMobile() ? 30 : 40} height={UtilidadeService.isMobile() ? 30 : 40} style={{ borderRadius: "50%" }} />,
            headerClassName: 'super-app-theme--header',
            headerAlign: "center",
            align: "center"
        },
        {
            field: 'nome',
            headerName: UtilidadeService.isMobile() ? 'NOME' : 'JOGADOR',
            description: 'Nome do Jogador da Franquia escolhido',
            flex: 1,
            headerClassName: 'super-app-theme--header',
            minWidth: UtilidadeService.isMobile() ? 80 : 180,
            renderCell: (params) => {
                return (
                    <Box
                        sx={{
                            whiteSpace: UtilidadeService.isMobile() ? 'pre-wrap' : "nowrap",
                        }}
                    >
                        {params.value}
                    </Box>
                );
            },
            //valueGetter: (params: GridValueGetterParams) =>`${params.row.nome_Jogador_Escolhido || ''}`,
        },
        // {
        //     field: 'logo_Franquia',
        //     headerName: 'Logo',
        //     flex: 1,
        //     renderCell: (params) => params.value !== null ? <img src={params.value} width={45} height={50} /> : null,
        //     headerClassName: 'super-app-theme--header'
        // },
        {
            field: 'franquia_Atual',
            headerName: 'NBA',
            flex: 1,
            minWidth: UtilidadeService.isMobile() ? 80 : 180,
            headerClassName: 'super-app-theme--header',
            renderCell: (params) => {
                return (
                    <Box
                        sx={{
                            whiteSpace: UtilidadeService.isMobile() ? 'pre-wrap' : "nowrap",
                        }}
                    >
                        {params.value}
                    </Box>
                );
            },
        },
        {
            field: 'franquia_Atual_Liga',
            headerName: 'LIGA',
            flex: 1,
            minWidth: UtilidadeService.isMobile() ? 80 : 180,
            headerClassName: 'super-app-theme--header',
            sortable: UtilidadeService.isMobile() ? false : true,
            renderCell: (params) => {
                return (
                    <Box
                        sx={{
                            whiteSpace: UtilidadeService.isMobile() ? 'pre-wrap' : "nowrap",
                        }}
                    >
                        {params.value}
                    </Box>
                );
            },
        },
        {
            field: 'posicao',
            headerName: UtilidadeService.isMobile() ? 'POS' : 'POSIÇÃO',
            flex: 1,
            minWidth: 60,
            sortable: false,
            headerClassName: 'super-app-theme--header',
            renderCell: (params) => (carregaPosicao(params.value, null, null)),
            headerAlign: "center",
            align: "center"
        },
        {
            field: 'ativo',
            headerName: UtilidadeService.isMobile() ? 'SIT.' : 'SITUAÇÃO',
            flex: 1,
            minWidth: 60,
            sortable: false,
            headerClassName: 'super-app-theme--header',
            renderCell: (params) => params.value === true ? "ATIVO" : "INATIVO",
            headerAlign: "center",
            align: "center"
        }
    ];

    const autoCompleteSelectedOption = useMemo(() => {
        if (!selectedIdComplete) return null;

        const selectedOption = opcoesAutoCompleteJogador.find(opcao => opcao.codigo === selectedIdComplete);
        if (!selectedOption) return null;

        return selectedOption;
    }, [selectedIdComplete, opcoesAutoCompleteJogador]);

    const paginaJogadores = useMemo(() => {
        return Number(searchParamsJogadores.get("pagina") || "1");
    }, [searchParamsJogadores]);


    useEffect(() => {
        if (codigoLiga === "" || codigoLiga === null || codigoLiga === "0") {
            setShowModalMensagem(true);
            setDadosModalMensagem({
                acao: true,
                label: "",
                tipo: "warning",
                mensagem: "Favor selecionar uma liga!",
                display: "none",
                titulo: "Atenção"
            });

            setRedirecionar("/dashboard");
            return;
        }
        setIsLoading(true);
        const fetchData = async () => {
            setIsLoading(false);

            await LigaService.getDadosLigaPeloCodigo(Number(codigoLiga))
                .then((result) => {
                    setIsLoading(false);
                    const liga = result.dado;
                    // = liga.codigo_Temporada;
                    setDadosLiga(liga);

                    const lst: TDropOptions[] = liga.codigo_Tipo_Posicao_Confronto === 2
                        ? lstPosicaoAmericano.map((f) => ({ codigo: f.codigo, label: f.label, descricao: f.label }))
                        : lstReferenciasPosicao.map((f) => ({ codigo: f.codigo, label: f.label, descricao: f.label }));
                    setLstPosicoes(lst)

                })
                .catch((errors) => {
                    setShowModalMensagem(true);
                    setRemoveLoading(true);
                    if (errors.response.status === 401) {
                        setDadosModalMensagem({
                            acao: true,
                            label: "",
                            tipo: "info",
                            mensagem: "Sessão expirada!",
                            display: "none",
                            titulo: "Atenção"
                        });
                        logout();
                        setRedirecionar("0");
                        return;
                    }

                    setDadosModalMensagem({
                        acao: true,
                        label: "",
                        tipo: "error",
                        mensagem: errors.response.data.mensagem,
                        display: "none",
                        titulo: "Atenção"
                    });
                    setRedirecionar(`/usuario/liga/${codLocal}`);
                    return;
                });

            FranquiaService.getByIdLiga(Number(codigoLiga)).then(result => {
                let lstFranquia = result.dado.map((f, i) => ({ codigo: f.codigo, label: f.nome === null ? `Franquia ${i + 1} ` : f.nome }));
                setLstFranquias(lstFranquia);
            }).catch((errors) => {
                setRemoveLoading(true);
                setIsLoading(false);
                setShowModalMensagem(true);
                if (errors.response.data.statusHTTP === 401) {
                    setDadosModalMensagem({
                        acao: true,
                        label: "",
                        tipo: "error",
                        mensagem: "Sessão Expirada! 2",
                        display: "none",
                        titulo: "Atenção"
                    });
                    logout();
                    setRedirecionar("0");
                    return;
                }
                if (errors.response.data.mensagem !== undefined) {
                    setDadosModalMensagem({
                        acao: true,
                        label: "",
                        tipo: "error",
                        mensagem: errors.response.data.mensagem,
                        display: "none",
                        titulo: "Atenção"
                    });
                }
                else {
                    setDadosModalMensagem({
                        acao: true,
                        label: "",
                        tipo: "error",
                        mensagem: "Não foi possível carregar os dados da franquia! Favor entrar em contato com a TI",
                        display: "none",
                        titulo: "Atenção"
                    });
                }
            });

            FranquiaService.getFranquiaNBA()
                .then(result => {
                    let lstFranquiaNBA = result.dado.map((f, i) => ({ codigo: f.codigo_NBA, label: f.nome === null ? `Franquia ${i + 1} ` : f.nome }));
                    setLstFranquiasNBA(lstFranquiaNBA);
                }).catch((errors) => {
                    setRemoveLoading(true);
                    setIsLoading(false);
                    setShowModalMensagem(true);
                    if (errors.response.data.statusHTTP === 401) {
                        setDadosModalMensagem({
                            acao: true,
                            label: "",
                            tipo: "error",
                            mensagem: "Sessão Expirada! 2",
                            display: "none",
                            titulo: "Atenção"
                        });
                        logout();
                        setRedirecionar("0");
                        return;
                    }
                    if (errors.response.data.mensagem !== undefined) {
                        setDadosModalMensagem({
                            acao: true,
                            label: "",
                            tipo: "error",
                            mensagem: errors.response.data.mensagem,
                            display: "none",
                            titulo: "Atenção"
                        });
                    }
                    else {
                        setDadosModalMensagem({
                            acao: true,
                            label: "",
                            tipo: "error",
                            mensagem: "Não foi possível carregar os dados da franquia! Favor entrar em contato com a TI",
                            display: "none",
                            titulo: "Atenção"
                        });
                    }
                });

            CarregarDadosJogadores(true);
        }
        fetchData();
        setRemoveLoading(true);
    }, [codigoLiga]);


    const CarregarDadosJogadores = (atualizarAutoComplete: boolean) => {

        JogadorService.getTodosJogadores(Number(codigoLiga), selectedIdComplete, codigoFranquiaNbaFiltro, codigoFranquiaLigaFiltro, posicaoFiltro, ativoFiltro)
            .then(result => {
                setRowsJogadores(result.data.dado);
                const lstDrop: TDropOptions[] = result.data.dado.sort((a, b) => a.nome > b.nome ? 1 : -1)
                    .map((f, i) => ({ codigo: f.codigo, label: f.nome, descricao: f.codigo_NBA.toString() }));
                if (atualizarAutoComplete === true)
                    setOpcoesAutoCompleteJogador(lstDrop);
            }).catch((errors) => {
                setIsLoading(false);
                setShowModalMensagem(true);
                if (errors.response.data.statusHTTP === 401) {
                    setDadosModalMensagem({
                        acao: true,
                        label: "",
                        tipo: "error",
                        mensagem: "Sessão Expirada! 1",
                        display: "none",
                        titulo: "Atenção"
                    });
                    logout();
                    setRedirecionar("0");
                    return;
                }
                if (errors.response.data.mensagem !== undefined) {
                    setDadosModalMensagem({
                        acao: true,
                        label: "",
                        tipo: "error",
                        mensagem: errors.response.data.mensagem,
                        display: "none",
                        titulo: "Atenção"
                    });
                }
                else {
                    setDadosModalMensagem({
                        acao: true,
                        label: "",
                        tipo: "error",
                        mensagem: "Não foi possível carregar os dados dos jodadores! Favor entrar em contato com a TI",
                        display: "none",
                        titulo: "Atenção"
                    });
                }
            });
    }

    const handleSave = async (dados: IDetalheFranquia) => {
        setIsLoading(true);
        setIsLoading(false);
    };

    const handleDelete = (id: number) => {
        if (window.confirm("Realmente deseja apagar?")) {
            FranquiaService.deleteById(id)
                .then((result) => {
                    setShowModalMensagem(true);
                    setDadosModalMensagem({
                        acao: true,
                        label: "",
                        tipo: "success",
                        mensagem: "Registro excluido com sucesso!",
                        display: "none",
                        titulo: "Atenção"
                    });
                    setRedirecionar("/franquias");
                })
                .catch((errors) => {
                    setShowModalMensagem(true);
                    if (errors.response.status === 401) {
                        setDadosModalMensagem({
                            acao: true,
                            label: "",
                            tipo: "info",
                            mensagem: "Sessão expirada!",
                            display: "none",
                            titulo: "Atenção"
                        });
                        logout();
                        setRedirecionar("0");
                        return;
                    }
                    setDadosModalMensagem({
                        acao: true,
                        label: "",
                        tipo: "error",
                        mensagem: errors.response.data.mensagem,
                        display: "none",
                        titulo: "Atenção"
                    });
                });
        }
    };

    const toggleModalMensagem = () => {
        setShowModalMensagem(modalVisivel => !modalVisivel);
        redirecionar.length === 1 ? navigate(0) : navigate(redirecionar);
    };

    const MyCustomNoRowsOverlay = () => (
        <Grid container size={{xs:12, sm:12}} paddingTop={2} display="flex" justifyContent="center" textAlign="center"  >
            {!removeLoading ? <Loading />
                : <Typography>Sem Registro(s)</Typography>
            }
        </Grid>
    );

    const carregaPosicao = (posicao_1: string, posicao_2: string | null, posicao_3: string | null) => {
        let posicoes = `${UtilidadeService.verificaTipoPosicao(posicao_1)} ${posicao_2 !== null ? " | " : ""} ${posicao_2 !== null ? UtilidadeService.verificaTipoPosicao(posicao_2) : ""} ${posicao_3 !== null ? " | " : ""} ${posicao_3 !== null ? UtilidadeService.verificaTipoPosicao(posicao_3) : ""}`;

        let qtd = posicoes.split("|").length;
        let arrImagens = posicoes.split("|");

        let imgs = qtd === 1 ?
            <img src={arrImagens[0]} alt={"img1"} width={UtilidadeService.isMobile() ? 20 : 25} height={UtilidadeService.isMobile() ? 20 : 25} style={{ borderRadius: "50%" }}
                onError={({ currentTarget }) => {
                    currentTarget.onerror = null;
                    currentTarget.src = "../../../../semimagem.png";
                    currentTarget.style.borderRadius = "50%";
                    currentTarget.style.width = UtilidadeService.isMobile() ? "30px" : "40px";
                    currentTarget.style.height = UtilidadeService.isMobile() ? "30px" : "40px";
                }}
            />
            : qtd === 2 ?
                <>  <img src={arrImagens[0]} alt={"img1"} width={UtilidadeService.isMobile() ? 20 : 25} height={UtilidadeService.isMobile() ? 20 : 25} style={{ borderRadius: "50%" }} />
                    <img src={arrImagens[1]} alt={"img2"} width={UtilidadeService.isMobile() ? 20 : 25} height={UtilidadeService.isMobile() ? 20 : 25} style={{ borderRadius: "50%", marginLeft: 4 }} />
                </>
                : <> <img src={arrImagens[0]} alt={"img1"} width={UtilidadeService.isMobile() ? 20 : 25} height={UtilidadeService.isMobile() ? 20 : 25} style={{ borderRadius: "50%" }} />
                    <img src={arrImagens[1]} alt={"img2"} width={UtilidadeService.isMobile() ? 20 : 25} height={UtilidadeService.isMobile() ? 20 : 25} style={{ borderRadius: "50%", marginLeft: 4 }} />
                    <img src={arrImagens[2]} alt={"img3"} width={UtilidadeService.isMobile() ? 20 : 25} height={UtilidadeService.isMobile() ? 20 : 25} style={{ borderRadius: "50%", marginLeft: 4 }} />
                </>

        return imgs
    }


    const handleRedirect: GridEventListener<'rowClick'> = (params) => {
        let crypt = UtilidadeService.crypt(`J|${params.row.codigo.toString()}|0`);
        navigate(`/liga/jogadores/detalhe/${crypt}`);
    }

    return (
        <LayoutBaseDePagina
            titulo="Jogadores"
            barraDeFerramentas={
                <FerramentasDeDetalhe
                    mostrarBotaoApagar={false}
                    mostrarBotaoSalvarEFechar={false}
                    mostrarBotaoSalvar={false}
                    mostrarBotaoNovo={false}
                    aoClicarEmSalvar={save}
                    aoClicarEmVoltar={() => navigate("/dashboard")}
                />
            }
        >
            {showModalMensagem && <DialogMensagem dados={dadosModalMensagem} isModalVisible={showModalMensagem} onBackClickClose={toggleModalMensagem} />}
            <VForm ref={formRef} onSubmit={handleSave}>
                <Box margin={1} display="flex" flexDirection="column" component={Paper} variant="outlined">
                    <Grid container direction="column" padding={UtilidadeService.isMobile() ? 1 : 2} spacing={3}>
                        <Grid container size={{xs:12, sm:12}}>
                            <Grid  size={{xs:12, sm:12}} >
                                <Typography variant="h6" style={{ fontSize: UtilidadeService.isMobile() ? 16 : 20 }}>Lista de Jogadores</Typography>
                                <hr />
                            </Grid>
                            <Grid container size={{xs:12, sm:12}} spacing={2} paddingTop={2}>
                                <Grid  size={{xs:12, sm:3,md:3}} paddingBottom={2}>
                                    <Autocomplete
                                        openText="Abrir"
                                        closeText="Fechar"
                                        noOptionsText="Sem opções"
                                        loadingText="Carregando..."
                                        options={opcoesAutoCompleteJogador}
                                        loading={isLoading}
                                        disabled={isLoading}
                                        value={autoCompleteSelectedOption}
                                        size={UtilidadeService.isMobile() ? "small" : "medium"}
                                        onChange={(event, newValue) => { setSelectedIdComplete(newValue?.codigo); }}
                                        popupIcon={isLoading ? <CircularProgress size={UtilidadeService.isMobile() ? 16 : 28} /> : undefined}
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                label="Jogador"
                                                slotProps={{                                                   
                                                    inputLabel:{
                                                      style: {
                                                        fontSize: UtilidadeService.isMobile() ? 13 : 16
                                                      }  
                                                    }
                                                  }}
                                            />
                                        )}
                                    />
                                </Grid>
                                <Grid size={{xs:12, sm:2, md:2}} >
                                    <FormControl fullWidth disabled={isLoading}>
                                        <InputLabel id="demo-simple-select-label">Franquia NBA</InputLabel>
                                        <Select
                                            variant="outlined"
                                            value={codigoFranquiaNbaFiltro}
                                            label="Franquia NBA"
                                            onChange={(e) => setCodigoFranquiaNbaFiltro(Number(e.target.value))}
                                        >
                                            <MenuItem value={0}>Todas</MenuItem>
                                            {
                                                lstFranquiasNBA.map(item => (<MenuItem key={item.codigo} value={item.codigo}>{item.label}</MenuItem>))
                                            }

                                        </Select>
                                    </FormControl >
                                </Grid>
                                <Grid size={{xs:12, sm:2, md:2}} >
                                    <FormControl fullWidth disabled={isLoading}>
                                        <InputLabel id="demo-simple-select-label">Franquia Liga</InputLabel>
                                        <Select
                                            variant="outlined"
                                            value={codigoFranquiaLigaFiltro}
                                            label="Franquia Liga"
                                            onChange={(e) => setCodigoFranquiaLigaFiltro(Number(e.target.value))}
                                        >
                                            <MenuItem value={0}>Todas</MenuItem>
                                            <MenuItem value={-1}>Sem Franquia</MenuItem>
                                            {
                                                lstFranquias.map(item => (<MenuItem key={item.codigo} value={item.codigo}>{item.label}</MenuItem>))
                                            }

                                        </Select>
                                    </FormControl >
                                </Grid>
                                <Grid size={{xs:12, sm:2, md:2}} >
                                    <FormControl fullWidth disabled={isLoading}>
                                        <InputLabel id="demo-simple-select-label">Posição</InputLabel>
                                        <Select
                                            variant="outlined"
                                            value={posicaoFiltro}
                                            label="Posição"
                                            onChange={(e) => setPosicaoFiltro(e.target.value)}
                                            defaultValue={"0"}
                                        >
                                            <MenuItem value={"0"}>Todas</MenuItem>
                                            {
                                                lstPosicoes.map(item => (<MenuItem key={item.label} value={item.label}>{item.label}</MenuItem>))
                                            }

                                        </Select>
                                    </FormControl >
                                </Grid>
                                <Grid size={{xs:12, sm:1, md:1}} >
                                    <FormControl fullWidth disabled={isLoading}>
                                        <InputLabel id="demo-simple-select-label">Situação</InputLabel>
                                        <Select
                                            variant="outlined"
                                            value={ativoFiltro}
                                            label="Situação"
                                            defaultValue={1}
                                            onChange={(e) => setAtivoFiltro(Number(e.target.value))}
                                        >
                                            <MenuItem value={0}>Ambos</MenuItem>
                                            <MenuItem value={1}>Ativo</MenuItem>
                                            <MenuItem value={2}>Inativo</MenuItem>

                                        </Select>
                                    </FormControl >
                                </Grid>
                                <Grid  size={{xs:6, sm:2, md:2}} display={"flex"} justifyContent={"end"} alignSelf={"center"}>
                                    <Button
                                        color="primary"
                                        variant="contained"
                                        disableElevation
                                        onClick={() => CarregarDadosJogadores(false)}
                                        startIcon={<Icon>change_circle</Icon>}
                                    >
                                        Pesquisar
                                    </Button>
                                </Grid>
                            </Grid>
                            <Grid  size={{xs:12, sm:12, md:12}} margin={1} spacing={1} paddingBottom={1}>
                                {!removeLoading && <Loading />}
                            </Grid>
                            <Box sx={{
                                height: 'auto', width: '100%', backgroundColor: themeName === "light" ? "#cfcfcd" : "auto",
                                '& .super-app-theme--header': {
                                    backgroundColor: theme.palette.common.black,
                                    color: theme.palette.common.white
                                },
                                '& .super-app.negative': {
                                    color: 'red',
                                    fontWeight: 'bold'
                                },
                                '& .super-app.positive': {
                                    color: themeName === "light" ? "black" : "auto",
                                },
                            }}>
                                <DataGrid
                                    localeText={ptBR.components.MuiDataGrid.defaultProps.localeText}
                                    getRowId={(rows) => rows.codigo}
                                    rows={rowsJogadores !== undefined ? rowsJogadores : []}
                                    columns={columnsJogadores}
                                    initialState={{
                                        pagination: {
                                            paginationModel: {
                                                pageSize: 25,
                                            },
                                        },
                                    }}
                                    onRowClick={handleRedirect}
                                    pageSizeOptions={[25, 50, 75, 100]}
                                    autoHeight
                                    slots={{ noRowsOverlay: MyCustomNoRowsOverlay }}
                                    disableRowSelectionOnClick={UtilidadeService.isMobile() ? true : false}
                                    disableColumnFilter={UtilidadeService.isMobile() ? true : false}
                                    disableColumnMenu={UtilidadeService.isMobile() ? true : false}
                                    sx={{
                                        fontSize: UtilidadeService.isMobile() ? 11 : "auto",
                                    }}
                                />
                            </Box>
                        </Grid>
                    </Grid>
                </Box>
            </VForm>
        </LayoutBaseDePagina >
    );
}